// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boyd-card-box {
  cursor: pointer;
  border-radius: 20px;
  margin: 20px;
  height: 35px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-weight: 600 !important;
}
.boyd-card-box p {
  font-size: 16px;
}
.boyd-card-box p ion-icon {
  font-weight: bold;
  margin-left: 10px;
  color: var(--ion-color-success);
}
.boyd-card-box .rg-card-img {
  width: 58px;
  height: 50px;
}

@media screen and (min-width: 551px) {
  .boyd-card-box-active {
    padding: 10px;
  }
}
@media screen and (max-width: 550px) {
  .boyd-card-box-active {
    padding: 10px 10px 10px 0px;
  }
}

.boyd-card-box-active {
  border-radius: 20px;
  margin: 20px;
  font-weight: 600 !important;
}
.boyd-card-box-active p ion-icon {
  font-weight: bold;
  margin-left: 10px;
  color: var(--ion-color-success);
}
.boyd-card-box-active .rg-card-img {
  margin-left: 20px;
  position: relative;
  width: 60px;
  height: 42px;
  top: 12px;
}
.boyd-card-box-active .ios .rg-card-img {
  width: 58px !important;
  margin-left: 32px !important;
}

.card-connected {
  border: 2px solid #28BE10;
}
.card-connected img {
  transform: translate(30px, 2px) rotate(0deg);
}

.card-not-connected {
  border: 2px solid var(--ion-color-secondary);
}
.card-not-connected img {
  transform: translate(30px, 1px) rotate(18deg);
}

.success-icon-box {
  position: relative;
}
.success-icon-box ion-icon {
  position: absolute;
  bottom: 13px;
  z-index: 1;
  left: 40px;
}
@media (max-width: 480px) {
  .success-icon-box img {
    top: 16px;
  }
}

.boyd-img-signup {
  width: 300px;
  padding-left: 10px;
  padding-right: 10px;
}

.success-icon-box-signup {
  left: 20px;
  position: relative;
}
.success-icon-box-signup ion-icon {
  position: absolute;
  bottom: 13px;
  z-index: 1;
  font-size: 1.15rem;
  padding-right: 3px;
  padding-bottom: 3px;
}
.success-icon-box-signup img {
  top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/boyd-rewards-card/boyd-rewards-card.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AACJ;AACI;EACI,eAAA;AACR;AACQ;EACI,iBAAA;EACA,iBAAA;EACA,+BAAA;AACZ;AAGI;EACI,WAAA;EACA,YAAA;AADR;;AAOI;EADJ;IAEQ,aAAA;EAHN;AACF;AAII;EAJJ;IAKQ,2BAAA;EADN;AACF;;AAOA;EACI,mBAAA;EACA,YAAA;EACA,2BAAA;AAJJ;AAOQ;EACI,iBAAA;EACA,iBAAA;EACA,+BAAA;AALZ;AAQI;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AANR;AAQI;EACI,sBAAA;EACA,4BAAA;AANR;;AAWA;EACI,yBAAA;AARJ;AASI;EACI,4CAAA;AAPR;;AAWA;EACI,4CAAA;AARJ;AASI;EACI,6CAAA;AAPR;;AAYA;EACI,kBAAA;AATJ;AAUI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AARR;AAUI;EACI;IACI,SAAA;EARV;AACF;;AAYA;EACI,YAAA;EACA,kBAAA;EACA,mBAAA;AATJ;;AAYA;EACI,UAAA;EACA,kBAAA;AATJ;AAUI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AARR;AAUI;EACG,QAAA;AARP","sourcesContent":[".boyd-card-box {\n    cursor: pointer;\n    border-radius: 20px;\n    margin: 20px;\n    height: 35px;\n    display: flex;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600 !important;\n    \n    p {\n        font-size: 16px;\n\n        ion-icon {\n            font-weight: bold;\n            margin-left: 10px;\n            color: var(--ion-color-success);\n        }\n    }\n\n    .rg-card-img {\n        width: 58px;\n        height: 50px;\n    }\n    \n}\n\n.boyd-card-box-active {\n    @media screen  and (min-width: 551px) {\n        padding: 10px;     \n    }\n    @media screen and (max-width:550px) {\n        padding: 10px 10px 10px 0px;\n    }\n}\n\n\n\n\n.boyd-card-box-active {\n    border-radius: 20px;\n    margin: 20px;\n    font-weight: 600 !important;\n    \n    p {\n        ion-icon {\n            font-weight: bold;\n            margin-left: 10px;\n            color: var(--ion-color-success);\n        }\n    }\n    .rg-card-img {\n        margin-left: 20px;\n        position:relative;\n        width: 60px;\n        height: 42px;\n        top: 12px;\n    }\n    .ios .rg-card-img {\n        width: 58px !important;\n        margin-left: 32px !important;\n      }\n\n}\n\n.card-connected {\n    border: 2px solid #28BE10;\n    img {\n        transform: translate(30px, 2px) rotate(0deg);\n    }\n}\n\n.card-not-connected {\n    border: 2px solid var(--ion-color-secondary);\n    img {\n        transform: translate(30px, 1px) rotate(18deg);\n    }\n}\n\n\n.success-icon-box {\n    position: relative;\n    ion-icon{\n        position: absolute;\n        bottom: 13px;\n        z-index: 1;\n        left: 40px;\n    }\n    @media (max-width: 480px) {\n        img {\n            top:16px;\n        }\n    }\n}\n\n.boyd-img-signup {\n    width: 300px;\n    padding-left: 10px;\n    padding-right: 10px;\n}\n\n.success-icon-box-signup{\n    left: 20px;\n    position: relative;\n    ion-icon{\n        position: absolute;\n        bottom: 13px;\n        z-index: 1;\n        font-size: 1.15rem;\n        padding-right: 3px;\n        padding-bottom: 3px;\n    }\n    img {\n       top:5px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
